import React from 'react';
// import PropTypes from 'prop-types';
import Input from 'modules/common/Input';
import Button from 'modules/common/Button';
import FitContent from 'modules/common/FitContent';
import { appendCss, THEMES } from '../hooks/useTheme';

function Login() {
  React.useEffect(() => {
    appendCss('theme-style', THEMES.Dark);
  }, []);
  const handleLogin = (e) => {
    e.preventDefault();
    window.location.href =
      '/session?code=my-auth-code&partner_id=94e59136-01ab-4cf9-9c0b-41e32968c0a1';
  };
  return (
    <>
      <FitContent>
        <div className="m-auto w-full max-w-xs bg-gray-200 p-6 shadow border rounded-xl">
          <form onSubmit={handleLogin}>
            <div className="space-y-3">
              <div>
                <Input name="mobile_number" label="Mobile Number" type="tel" />
              </div>
              <div>
                <Input name="password" label="Password" type="password" />
              </div>
              <Button className="w-full" type="submit" primary>
                Login
              </Button>
            </div>
          </form>
        </div>
      </FitContent>
      <div className="text-xs text-center py-3 text-gray-500">
        Gamebox Lobby v0.1.0
      </div>
    </>
  );
}

Login.propTypes = {};

export default Login;
